import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "serp__filter-item--dropdown" }
const _hoisted_2 = { class: "q-dropdown q-position-relative" }
const _hoisted_3 = {
  key: 0,
  class: "input-group input-group-sm mb-1 filter-search__container"
}
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = {
  key: 1,
  class: "dropdown-divider__container"
}

import {computed, ref, inject} from 'vue';
import DropdownButton from '@/components/SerpPage/FiltersContainer/FiltersList/DropdownButton.vue'
import InputRangeItem from './FilterItem/InputRangeItem.vue'
import CategoryItem from './FilterItem/CategoryItem.vue'
import CheckboxItem from './FilterItem/CheckboxItem.vue'
import BoxItem from "@/components/SerpPage/FiltersContainer/FiltersList/FilterItem/BoxItem.vue";
import MultiRangeSlider from "@/components/SerpPage/FiltersContainer/FiltersList/FilterItem/MultiRangeSlider.vue";
import {SmartSearchTranslationsInterface} from "@/core/types";
import { resolveCustomSmartSearchConfig } from '@/core/customSmartSearchConfig'


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterDropdown',
  props: ['filter'],
  setup(__props) {

const isOpen = ref(false);

const props = __props
const forbiddenSearchTypes = computed(()=>{
  return props.filter.type === 'range' || props.filter.type === 'rangeSlider' || props.filter.type === 'category'
})
const accordionSearchEnabled = resolveCustomSmartSearchConfig().accordionSearchEnabled

const computedClass = computed(() => {
      if (props.filter.type === 'box') {
        return `serp__filter-item--${props.filter.type}`
      }
      const classList = [
        'serp__filter-item--group',
        `serp__filter-item--${props.filter.type}`,
        'q-list-group',
        'q-list-group-flush',
        'q-list-group-collapse',
      ]
      if (isOpen.value) {
        classList.push('q-d-block')
      }
      return classList
    })
;

let searchQuery = ref('');
const baseValues = computed(() => Array.isArray(props.filter?.data?.values) ? props.filter.data.values : [])
const filteredValues = computed(() => {
  const values = baseValues.value
  if (searchQuery.value === '') {
    return values
  }
  const query = searchQuery.value.toLowerCase()
  return values.filter(value => {
    const label = typeof value?.label === 'string' ? value.label.toLowerCase() : ''
    return label.includes(query)
  })
})
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!

function closeDropdown() {
  isOpen.value = false
}


return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createVNode(DropdownButton, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = !isOpen.value)),
        label: __props.filter.label,
        "is-open": isOpen.value
      }, null, 8, ["label", "is-open"]),
      (isOpen.value)
        ? (_openBlock(), _createElementBlock("ul", {
            key: 0,
            class: _normalizeClass(["q-dropdown-menu q-shadow-sm q-rounded-3", computedClass.value])
          }, [
            (_unref(accordionSearchEnabled) && !forbiddenSearchTypes.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "q-form-control filter-search__input",
                    "aria-label": "Filter search input",
                    placeholder: _unref(SmartSearchTranslations).serp.filterSearchHeader,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(searchQuery) ? (searchQuery).value = $event : searchQuery = $event))
                  }, null, 8, _hoisted_4), [
                    [_vModelText, _unref(searchQuery)]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(accordionSearchEnabled) && !forbiddenSearchTypes.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_5, _cache[7] || (_cache[7] = [
                  _createElementVNode("hr", { class: "dropdown-divider" }, null, -1)
                ])))
              : _createCommentVNode("", true),
            (__props.filter.type === 'checkbox')
              ? (_openBlock(), _createBlock(CheckboxItem, {
                  key: 2,
                  filterDataValues: filteredValues.value,
                  field: __props.filter.field,
                  onCloseDropdown: _cache[2] || (_cache[2] = ($event: any) => (isOpen.value = false))
                }, null, 8, ["filterDataValues", "field"]))
              : _createCommentVNode("", true),
            (__props.filter.type === 'box' )
              ? (_openBlock(), _createBlock(BoxItem, {
                  key: 3,
                  filterDataValues: filteredValues.value,
                  field: __props.filter.field,
                  onCloseDropdown: _cache[3] || (_cache[3] = ($event: any) => (isOpen.value = false))
                }, null, 8, ["filterDataValues", "field"]))
              : _createCommentVNode("", true),
            (__props.filter.type === 'range')
              ? (_openBlock(), _createBlock(InputRangeItem, {
                  key: 4,
                  filterData: __props.filter.data,
                  field: __props.filter.field,
                  onCloseDropdown: _cache[4] || (_cache[4] = ($event: any) => (isOpen.value = false))
                }, null, 8, ["filterData", "field"]))
              : _createCommentVNode("", true),
            (__props.filter.type === 'rangeSlider')
              ? (_openBlock(), _createBlock(MultiRangeSlider, {
                  key: 5,
                  filterData: __props.filter.data,
                  field: __props.filter.field,
                  onCloseDropdown: _cache[5] || (_cache[5] = ($event: any) => (isOpen.value = false))
                }, null, 8, ["filterData", "field"]))
              : _createCommentVNode("", true),
            (__props.filter.type === 'category')
              ? (_openBlock(), _createBlock(CategoryItem, {
                  key: 6,
                  filterData: __props.filter.data,
                  field: __props.filter.field,
                  onCloseDropdown: _cache[6] || (_cache[6] = ($event: any) => (isOpen.value = false))
                }, null, 8, ["filterData", "field"]))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true)
    ])), [
      [_directive_click_outside, closeDropdown]
    ])
  ]))
}
}

})